import { UserPermissions } from '../types/permissions';

// 权限服务API类
class PermissionServiceAPI {
  private baseURL: string;

  constructor() {
    const apiBase = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000').replace(/\/$/, '');
    this.baseURL = `${apiBase}/api/v1`;
  }

  /**
   * 获取用户权限信息
   */
  async getUserPermissions(): Promise<UserPermissions> {
    try {
      const response = await fetch(`${this.baseURL}/users/permissions/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取用户权限信息失败:', error);
      // 返回默认权限（无权限）
      return {
        is_authenticated: false,
        role: null,
        staff_sub_role: null,
        customer_sub_role: null,
        can_view_sensitive_info: false,
        can_view_financial_info: false,
        can_view_statistics: false,
        statistics_level: 'none',
        is_hq_staff: false,
        is_warehouse_supervisor: false,
        is_warehouse_staff: false,
        is_main_account: false,
        is_sub_account: false,
        assigned_warehouse_ids: [],
        assigned_project_ids: [],
      };
    }
  }

  /**
   * 检查用户是否有特定权限
   */
  async checkPermission(permission: string, level?: string): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseURL}/users/check-permission/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          permission,
          level,
        }),
      });

      if (!response.ok) {
        return false;
      }

      const data = await response.json();
      return data.has_permission;
    } catch (error) {
      console.error('检查权限失败:', error);
      return false;
    }
  }

  /**
   * 获取用户可访问的菜单
   */
  async getAccessibleMenus(): Promise<any[]> {
    try {
      const response = await fetch(`${this.baseURL}/users/accessible-menus/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        return [];
      }

      const data = await response.json();
      return data.menus;
    } catch (error) {
      console.error('获取可访问菜单失败:', error);
      return [];
    }
  }

  /**
   * 获取用户可访问的统计数据
   */
  async getAccessibleStatistics(): Promise<any[]> {
    try {
      const response = await fetch(`${this.baseURL}/users/accessible-statistics/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        return [];
      }

      const data = await response.json();
      return data.statistics;
    } catch (error) {
      console.error('获取可访问统计数据失败:', error);
      return [];
    }
  }
}

// 导出单例实例
export const permissionServiceAPI = new PermissionServiceAPI();
export default permissionServiceAPI;
